import { cloneDeep } from 'lodash-es';
import * as S from './ExcludeSettings.styled';
import { ChooseAdvertisers } from 'components';
import { Buttons, ParagraphWithTooltip } from 'components';
import { DeleteIcon } from 'assets/icons';

const ExcludeAdvertisers = ({ onChange, value }) => {
  const clearAll = () => {
    onChange([]);
  };

  const deleteAdvertiser = (id) => {
    let newAdv = cloneDeep(value);
    newAdv = newAdv.filter((adv) => adv?.pb_number !== id);
    onChange(newAdv);
  };

  return (
    <>
      <S.TextField>
        <S.Title>Exclude Advertisers:</S.Title>
      </S.TextField>
      <S.FieldsWrap>
        <S.ActionField>
          <S.BtnWrap>
            <ChooseAdvertisers
              selectedAdvertisers={value}
              setSelectedAdvertisers={onChange}
              title='Exclude Advertisers'
            />
          </S.BtnWrap>
          {value?.length > 0 && (
            <>
              <S.Line />
              <S.BtnWrapp>
                <Buttons.TertiaryNormal
                  id='categories_clear_all'
                  onClick={clearAll}
                  style={{ marginLeft: '16px' }}
                >
                  Clear All
                </Buttons.TertiaryNormal>
              </S.BtnWrapp>
              <S.Wrap>
                <S.SelectedItem>
                  {value?.map((item) => (
                    <S.Item key={item?.pb_number}>
                      <ParagraphWithTooltip text={item?.pb_name} />
                      <S.IconWrapp onClick={() => deleteAdvertiser(item?.pb_number)}>
                        <DeleteIcon />
                      </S.IconWrapp>
                    </S.Item>
                  ))}
                </S.SelectedItem>
              </S.Wrap>
            </>
          )}
        </S.ActionField>
      </S.FieldsWrap>
    </>
  );
};

export default ExcludeAdvertisers;
